import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;

@Component({
  selector: 'app-deleted-user',
  templateUrl: './deleted-user.component.html',
  styleUrls: ['./deleted-user.component.scss']
})

export class DeletedUserComponent {
  public dataListing:any=[];
  public AllData:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public searchKey1:any='';
  public sortType:any='desc';


  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");   
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

  getDetail(page:any){
    var type:any='';
    // if(this.CurrentUrl=='/creators'){
    //   type="Individual Creator";
    // } else if(this.CurrentUrl=='/organisations'){
    //   type="Organisation";
    // } else{
    //   type="Customer";
    // }      
    var detail={
      "search_by_name_email":this.searchKey,
      "search_by_role":this.searchKey1,
      sortBy:'createdAt',
 sortOrder:this.sortType

    }; 
    this.service.PostApis(detail,'/user-delete-listing?page='+page).subscribe(((response:any)=>{
      if(response.success ==1) {  
        this.AllData=response.data;
        if(response.data.record.length !=0){
          response.data.record.filter((el:any)=>{
            if(el.reason ==''){
              if(el.delete_reason.length !=0){
                el.reason = el.delete_reason[0].name;
              }             
            }
          })
        }
        this.dataListing= response.data.record;  
        this.totalCount = response.data.total; 
        this.loading=false;
      } else {
        this.dataListing=[];  
        this.AllData=[];
        this.totalCount =  response.data.total; 
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  reset(){
    this.p=1;
    this.searchKey='';
    this.searchKey1='';
    this.getDetail(this.p);
  }
}
